import { useSelector } from "react-redux";
import "./Loader.css";
import { useTranslation } from "react-i18next";

const Loader = () => {
  const [t] = useTranslation();
  const loaderState = useSelector((state) => state.loader.isLoading);

  return (
    <>
      {loaderState && (
        <div className="loader-containner">
          <div>{t("loading.text")}</div>
        </div>
      )}
    </>
  );
};

export default Loader;
